export default "__VITE_ASSET__emSeLjB$__"